export default __webpack_public_path__ + "static/media/icons-currency-sapphire-sml.ee72694d.png";